<template>
<div class="consulAddDialog">
  <div class="queRenBtn" style="margin-bottom:30px;">
    <el-button @click="issueCJ">基础信息</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <el-button @click="jbinfo">审核人员</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span> 
    <el-button type="primary" @click="blbanli">打印签到表</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
    <el-button class="qubtn">活动总结</el-button><span class="qubtn_span"></span> 
  </div>
  <div v-if="moduleShow1"> 
    <LookProject ref='LookProject' :rowid='rowid' :readonlys='readonlyInfo' @close='closeViewInfo  '></LookProject>
  </div>
  <div v-if="moduleShow2">
    <AuditorsList  ref="AuditorsList" :readonlyApproval='readonlyApproval' :rowid='rowid' @close="closeViewApproval" ></AuditorsList>
  </div>
  <div v-if="moduleShow3">
    <SignInForm ref="SignInForm" :readonlyForm='readonlyForm' :rowid='rowid' @close="closeViewForm" ></SignInForm>
  </div> 
  <div v-if="moduleShow4">
    <ActivitySummary ref="ViewJieGuo" :readonlySummary='readonlySummary' :readonlyjg='readonlyjg' :rowid='rowid' @close="closeViewSummary" ></ActivitySummary>
  </div> 
</div>
</template>

<script>
import { post } from "@/api/requrestHttp";
import LookProject from "@/views/governmentAffairschildren/gridding/lookproject.vue";
import AuditorsList from "@/views/governmentAffairschildren/gridding/auditorsList.vue";
import SignInForm from "@/views/governmentAffairschildren/gridding/signInForm.vue";
import ActivitySummary from "@/views/governmentAffairschildren/gridding/activitySummary.vue"; 
import { tabdata } from "@/mixins/tabledataMix.js";
export default {
    components: { LookProject,AuditorsList,SignInForm,ActivitySummary },
    props: ["rowid"],
    mixins: [tabdata],
    data() {
        return {
          id:this.rowid,
          handleStatus:'',
          readonlyInfo:true,
          readonlyApproval:false,
          readonlyForm:false,
          readonlySummary:false, 
          showLookProject : false,
          showAuditorsList : false,
          showSignInForm : false, 
          moduleShow1:false,
          moduleShow2:false,
          moduleShow3:false,
          moduleShow4:false, 
          showGongShi: false,   
        }
    },
    mounted(){
      console.log("+++",this.rowid);
      this.$nextTick(() => {  
        this.blbanli() 
      });
      
    },
    methods: { 
      closeViewInfo() {
        this.$emit("close")   
      },
      closeViewApproval() {
        this.$emit("close")   
      },
      closeViewForm() {
        this.$emit("close")   
      },
      closeViewSummary() {
        this.$emit("close")   
      },
      issueCJ() {
        this.moduleShow1 = true;
        this.moduleShow2 = false;
        this.moduleShow3 = false;
        this.moduleShow4 = false;  
        setTimeout(() => {
          this.$nextTick(() => {  
            this.$refs.LookProject.id = this.rowid;
            this.$refs.LookProject.readonly = true;
            this.$refs.LookProject.getData();
            this.$refs.LookProject.getDetail();
            this.$refs.LookProject.mapInit("container")
          })
        }, 100)
      },
      jbinfo() {
          this.moduleShow1 = false;
          this.moduleShow2 = true;
          this.moduleShow3 = false;
          this.moduleShow4 = false; 
          setTimeout(() => {
            this.$nextTick(() => {  
              this.$refs.AuditorsList.id = this.rowid;
              this.$refs.AuditorsList.getData();
              this.$refs.AuditorsList.getUnApproveInfo();
            })
          }, 100)
      },
      blbanli() {
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = true;
          this.moduleShow4 = false;
          setTimeout(() => {
            this.$nextTick(() => {  
              this.$refs.SignInForm.id = this.rowid;
              this.$refs.SignInForm.getData();
              this.$refs.SignInForm.getServiceItemsPerson();
            })
          }, 100)
      },
      blresult() { //结果
          this.moduleShow1 = false;
          this.moduleShow2 = false;
          this.moduleShow3 = false;
          this.moduleShow4 = true;
          setTimeout(() => {
            this.$nextTick(() => {  
              this.$refs.ActivitySummary.id = this.rowid;
              this.$refs.ActivitySummary.readonly = true; 
              this.$refs.ActivitySummary.getData();
              this.$refs.ActivitySummary.getDetail();
            })
          }, 100)
      }, 
    }
}
</script>

<style lang="less" scoped>
.consulAddDialog {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.centerBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.queRenBtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  .qubtn{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  } 
  .qubtn :hover{ 
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span{
      color:#409EFF; 
      margin-top:10px
  }

}
</style>